<script lang="ts">
  import Caret from "~icons/ph/caret-down";
</script>

<details>
  <summary>Can I tell people about the settlement?<Caret /></summary>
  <p>
    The settlement is strictly privileged and confidential. This means that you must not publish or discuss the terms of
    the settlement with anyone except any professional advisor that owes you a duty of confidence (i.e. your solicitor
    or accountant) or by Court order. Please note that, if you fail to keep to these obligations, easyJet may be
    entitled to take legal action against you.
  </p>
</details>
